import React from "react";
import PainelShimmerChrome, { Skeleton } from "../PainelShimmerChrome";
import { useTheme } from "../../../theme/useTheme";
import "./AuthLoadingSkeleton.scss";

const AuthLoadingSkeleton: React.FC = () => {
  const { isDarkMode } = useTheme();

  return (
    <PainelShimmerChrome isDarkMode={isDarkMode}>
      <div
        className={`auth-loading-skeleton ${isDarkMode ? "auth-loading-skeleton--dark" : ""}`}
        aria-busy="true"
        aria-label="Carregando autenticação"
      >
        <div className="auth-loading-skeleton__card">
          <Skeleton height={40} width={160} />
          <Skeleton height={18} width="68%" />
          <Skeleton height={14} width="84%" />
          <Skeleton height={42} width="100%" borderRadius={8} />
        </div>
      </div>
    </PainelShimmerChrome>
  );
};

export default AuthLoadingSkeleton;
